import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'PaginationComponent',
})

interface Props {
  modelValue: { page: number; per: number }
  pageCount: number
  listItemsPerPage?: number[]
  totalVisiblePages?: number
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    pageCount: {},
    listItemsPerPage: { default: () => [10, 25, 50] },
    totalVisiblePages: { default: 6 },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:model-value'],
  setup(__props: any, { emit }) {





const updateModelValue = (page: number, per: number) => {
  emit('update:model-value', { page, per })
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_select, {
            "model-value": _ctx.modelValue.per,
            items: _ctx.listItemsPerPage,
            disabled: _ctx.disabled,
            label: "Кол-во",
            density: "comfortable",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateModelValue(1, $event)))
          }, null, 8, ["model-value", "items", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_col, { cols: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_pagination, {
            "model-value": _ctx.modelValue.page,
            length: _ctx.pageCount,
            "total-visible": _ctx.totalVisiblePages,
            disabled: _ctx.disabled,
            density: "comfortable",
            "show-first-last-page": "",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (updateModelValue($event, _ctx.modelValue.per)))
          }, null, 8, ["model-value", "length", "total-visible", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})